import React from 'react';
import { Typography, useTheme } from '@mui/material';

type PropTypes = {
  text: string;
  textShadow?: string;
};
export const CardTitle = ({ text, textShadow }: PropTypes) => {
  const theme = useTheme();

  return (
    // We should be using the same header as in the profile page but styles currently don't sync...
    // <Typography
    //   variant="h5"
    //   textAlign="center"
    //   sx={{
    //     textShadow:
    //       theme.palette.mode === 'dark'
    //         ? `0 0 0px ${theme.palette.secondary.main}, 0 0 0px ${theme.palette.secondary.main}, 0px 0px 16px ${theme.palette.secondary.main}`
    //         : 'none',
    //   }}
    // >
    //   {text}
    // </Typography>
    <Typography
      variant="h5"
      overflow="hidden"
      sx={{
        color: theme.palette.text.primary,
        textAlign: 'center',
        padding: '8px',
        textShadow:
          theme.palette.mode === 'dark'
            ? `0 0 4px ${textShadow || theme.palette.secondary.main},
         0 0 4px ${textShadow || theme.palette.secondary.main},
         0px 0px 16px ${textShadow || theme.palette.secondary.main}`
            : 'none',
      }}
    >
      {text}
    </Typography>
  );
};
